import { baseApi } from './baseApi';
import {
  parseInitiateKycResponse,
  parseKraDetailsResponse,
  parseCompleteKycResponse
} from '../parsers/kyc.parsers';

/**
 * KYC API service
 * Extends the base API with KYC (Know Your Customer) endpoints
 * 
 * @description
 * This API slice is ready for endpoint implementation.
 * Endpoints will be added as requirements are defined.
 */
export const kycApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Initiate KYC
    initiateKyc: builder.mutation({
      query: (payload) => ({
        url: 'api/kyc/initiate',
        method: 'POST',
        body: payload,
      }),
      transformResponse:parseInitiateKycResponse,
      // transformResponse: (response) => {
      //   return parseInitiateKycResponse(response);
      // },
      // transformErrorResponse: (error) => {
      //   return parseKycErrorResponse(error);
      // },
      invalidatesTags: ['KYC'],
    }),



    


    // Get KRA Details
    getKraDetails: builder.query({
      query: (params) => ({
        url: 'api/kyc/kra-details',
        method: 'GET',
        params: params,
      }),
      transformResponse: parseKraDetailsResponse,
    }),

    // Update KRA Details
    updateKraDetails: builder.mutation({
      query: (payload) => ({
        url: 'api/kyc/update-kra-details',
        method: 'POST',
        body: payload,
      }),
    }),

    // Re-KYC
    reKyc: builder.mutation({
      query: (payload) => ({
        url: 'api/kyc/rekyc',
        method: 'POST',
        body: payload,
      }),
    }),

    updateDigioStatus: builder.mutation({
      query: () => ({
        url: 'api/kyc/update-digio-status',
        method: 'POST',
      }),
    }),

    // Complete KYC
    completeKyc: builder.mutation({
      query: (payload) => ({
        url: 'api/kyc/complete',
        method: 'POST',
        body: payload,
      }),
      transformResponse: parseCompleteKycResponse,
    }),
  }),
});

// Export hooks for usage in components
export const {
  useInitiateKycMutation,
  useLazyGetKraDetailsQuery,
  useUpdateKraDetailsMutation,
  useReKycMutation,
  useCompleteKycMutation,
  useUpdateDigioStatusMutation,
} = kycApi;

